var AdaptiveImage = require("../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "static/media/greenCircularTick.06754238.png","uri@2x": __webpack_public_path__ + "static/media/greenCircularTick.d77765c5.png","uri@3x": __webpack_public_path__ + "static/media/greenCircularTick.837da319.png",
    width: 20,
    height: 20
});